import { RouteObject } from '@rocketlane/rocket-router';
import { SkillBuilderRemote } from 'components/pages/skill-builder-remote';
import { SecureRoute } from '../route-with-permission-check';
import { ROUTE_PATHS } from '../routes-paths';

export const skillBuilderRoutes: RouteObject[] = [
  {
    path: ROUTE_PATHS.SKILL_BUILDER,
    children: [
      {
        index: true,
        element: (
          <SecureRoute>
            <SkillBuilderRemote />
          </SecureRoute>
        ),
      },
      {
        path: ROUTE_PATHS.MATCH_ALL,
        element: (
          <SecureRoute>
            <SkillBuilderRemote />
          </SecureRoute>
        ),
      },
    ],
  },
];
